const doc = [({"en":({"js":({"admin":({"team_users":({"show":({"the_user_was_removed_from_the_team":"The user was removed from the team"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;